import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useLocation } from "react-router-dom";
import "./Editplan.css";
import cx from "./sidecards.module.css";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import {
  billFrequencyList,
  currencyList,
  discountList,
  redemptionListDetails,
} from "../../constants/roles";
import moment from "moment";
import { twoDecimalPlaces } from "../../utils/utilsHandlerFunctions";
import { httpSuperAdmin } from "../../Apis/commonApis";
import { ShowSwal } from "../../utils/alertSwal";

export default function EditCoupons() {
  const location = useLocation();

  const [show, setShow] = useState(false);
  const [planName, setPlanName] = useState(""); // in case if owner want to change the plan name
  const [editsingleObject, setEditsingleObject] = useState([]);
  const [linkedSites, setLinkedSites] = useState([]);

  const [discountValue, setdiscountValue] = useState(0);
  const handleClose = () => {
    setShow(false);
    setdiscountValue(0);
  };
  const [popupStatus, setPopupStatus] = useState("");
  const handleShow = (text) => {
    setShow(true);
    setPopupStatus(text);
    if (text === "Edit Links") {
      linkedAccountChangeHandler(
        "linkedAccount" in editsingleObject &&
          editsingleObject?.linkedAccount?.[0]
      );
    }
  };
  // ------------------------------------- / currency List Selection / --------------------------------- //

  const [currency, setCurrency] = useState("");
  const currencyOptions = currencyList.map(({ value, label }) => {
    return { value, label };
  });

  function currencyHandler(event) {
    setCurrency(event.label);
  }

  // ------------------------------------- / Discount Type Selection / --------------------------------- //

  const [discount, setdiscount] = useState("");
  const discountOptions = discountList.map(({ value, label }) => {
    return { value, label };
  });

  function discountHandler(event) {
    setdiscount(event.label);
  }

  // ------------------------------------- / billFrequencyList List Selection / --------------------------------- //

  const [billFrequency, setbillFrequency] = useState("");
  const billFrequencyOptions = billFrequencyList.map(({ value, label }) => {
    return { value, label };
  });
  function billFrequencyHandler(event) {
    setbillFrequency(event.label);
  }

  // ------------------------------------- / Redemption List Selection / --------------------------------- //

  const [redemption, setredemption] = useState("1");
  const [redemptionInput, setredemptionInput] = useState(false);
  const redemptionOptions = redemptionListDetails.map(({ value, label }) => {
    return { value, label };
  });
  function redemptionHandler(event) {
    if (event.value === "fewno") {
      setredemptionInput(true);
    }
    if (event.value === "one_time") {
      setredemptionInput(false);
      setredemption("1");
    }
    if (event.value === "indefinite") {
      setredemptionInput(false);
      setredemption("0");
    }
  }

  // ------------------------------------- / Linked Plans / --------------------------------- //
  let [selectedLinkedPlans, setselectedLinkedPlans] = useState([]);
  const [LinkedPlansOption, setLinkedPlansOption] = useState([]);

  function linkedPlansHandleChange(event) {
    let array = [];
    event.forEach((option) => {
      array.push(option.value);
    });
    setselectedLinkedPlans(array);
  }

  // ------------------------------------- / Linked Add-Ons / --------------------------------- //
  let [selectedLinkedAddOns, setselectedLinkedAddOns] = useState([]);
  const [LinkedAddOnsOption, setLinkedAddOnsOption] = React.useState([]);

  function linkedAddOnsHandleChange(event) {
    let array = [];
    event.forEach((option) => {
      array.push(option.value);
    });
    setselectedLinkedAddOns(array);
  }
  // ------------------------------------- / Linked Accounts / --------------------------------- //
  const [specificAccountsOptions, setSpecificAccountsOptions] = useState([]);
  const [linkedSpecificAccount, setLinkedSpecificAccount] = useState("");
  const [linkedAccount, setLinkedAccount] = useState("");
  function linkedAccountChangeHandler(name) {
    if (name == "existingUsers" || name == "newUsers" || name == "All") {
      setLinkedAccount(name);
    } else {
      setLinkedAccount("specific");
    }
  }

  function linkedSpecificAccountChangeHandler(options) {
    setLinkedSpecificAccount(options.map((item) => item.value));
  }

  // ------------------------------------- / Linked Sites / --------------------------------- //
  let [selectedLinkedSites, setselectedLinkedSites] = useState([]);
  const [LinkedSitesOption, setLinkedSitesOption] = useState([]);

  function resetCoupon() {
    setselectedLinkedSites([]);
    setLinkedSpecificAccount([]);
    setLinkedAccount("");
    setselectedLinkedAddOns([]);
    setselectedLinkedPlans([]);
  }

  useEffect(() => {
    getCouponById();
    getLinkedPlans();
    getFandFapp();
    adminlisting();
  }, []);

  const getLinkedPlans = async () => {
    const res = await httpSuperAdmin(`getPlans`, null, null);
    if (res.status) {
      setLinkedPlansOption([
        { value: "All", label: "All" },
        ...res.plansData?.map((item) => {
          return { label: item.planName, value: item.planName };
        }),
      ]);
    }
  };

  const getCouponById = async () => {
    const res = await httpSuperAdmin(
      `getCoupon?couponId=${location?.state?.selectedFullObject[0]?._id}`,
      null,
      null
    );
    if (res.status) {
      let couponData = res?.data[0];
      setEditsingleObject(couponData);
      setselectedLinkedPlans(couponData?.linkedPlan ?? []);
    }
  };

  const getFandFapp = async () => {
    const res = await httpSuperAdmin(`getFandFapp`, null, null);
    if (res.status) {
      let getallffdata = [];
      res.data?.map((item) => {
        getallffdata.push({ value: item.addOnId, label: item.addOnId });
      });
      setLinkedAddOnsOption([{ value: "All", label: "All" }, ...getallffdata]);
    }
  };

  const adminlisting = async () => {
    const res = await httpSuperAdmin(`getOwners`, null, null);
    if (res.status) {
      const responseData = res?.data;
      let ownersData = [];
      let subscriptiondata = [];
      responseData.forEach((element) => {
        ownersData.push({
          value: element?._id,
          label: element?.companyName,
          plans: element?.subscriptionPlanData?.map(
            (item) => item.SubscriptionPlan
          ),
        });
        if (element?.subscriptionPlanData?.length > 0) {
          element?.subscriptionPlanData.forEach((subelement, index) => {
            subscriptiondata.push({
              label: subelement.careSiteName,
              value: subelement._id,
              ownerId: element._id,
              planName: subelement.SubscriptionPlan,
            });
          });
        }
      });
      setSpecificAccountsOptions(ownersData);
      setLinkedSitesOption([
        { value: "All", label: "All", ownerId: "" },
        ...subscriptiondata,
      ]);
    }
  };

  const editPlanDetails = async () => {
    let data = {
      linkedPlan: selectedLinkedPlans.join(" "),
      couponType: planName ? planName : editsingleObject?.couponType,
      id: location?.state?.selectedFullObject[0]?._id,
    };
    const res = await httpSuperAdmin(`editCoupon`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getCouponById();
      handleClose();
    }
  };

  const editBillingDetails = async () => {
    let data = {
      billFrequency: billFrequency
        ? billFrequency
        : editsingleObject?.billFrequency,
      discountValue: discountValue
        ? twoDecimalPlaces(discountValue)
        : twoDecimalPlaces(editsingleObject?.discountValue),
      // currency: currency ? currency : editsingleObject?.currency,
      discountType: discount ? discount : editsingleObject?.discountType,
      id: location?.state?.selectedFullObject[0]?._id,
    };
    const res = await httpSuperAdmin(`editCoupon`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getCouponById();
      handleClose();
    }
  };

  const editRedemptionDetails = async () => {
    let data = {
      redemptionType: redemption,
      id: location?.state?.selectedFullObject[0]?._id,
    };
    const res = await httpSuperAdmin(`editCoupon`, data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      getCouponById();
      handleClose();
      setredemption("");
      if (redemption < 2) setredemptionInput(false);
    }
  };

  const editLinksDetails = async () => {
    let data = {
      linkedAccount:
        linkedAccount === "specific" ? linkedSpecificAccount : linkedAccount,
      specificAccount: linkedAccount === "specific" ? true : false,
      linkedAddOn:
        selectedLinkedAddOns?.length > 0
          ? selectedLinkedAddOns
          : editsingleObject?.linkedAddOn,
      linkedPlan:
        selectedLinkedPlans?.length > 0
          ? selectedLinkedPlans
          : editsingleObject?.linkedPlan,
      linkedSites:
        selectedLinkedSites?.length > 0
          ? selectedLinkedSites
          : // : editsingleObject?.linkedSites?.[0],
            linkedSites?.map((item) => {
              return item?.value;
            }),
      id: location?.state?.selectedFullObject?.[0]?._id,
    };
    const res = await httpSuperAdmin(`editCoupon`, data, null);
    ShowSwal(res.status, res?.message ?? "");
    if (res.status) {
      getCouponById();
      handleClose();
      resetCoupon();
      if (redemption < 2) setredemptionInput(false);
    }
  };

  const creationDate = moment(editsingleObject?.couponCreationDate).format(
    "MM-DD-YYYY, h:mm"
  );

  function hasAtLeastOneSelectedPlan(plans, selectedPlans) {
    return selectedPlans.some((plan) => plans.includes(plan));
  }

  const filteredSiteOpts = useMemo(() => {
    const filterByOwner = LinkedSitesOption?.filter((item) =>
      linkedSpecificAccount?.includes(item.ownerId)
    );
    return selectedLinkedPlans?.includes("All")
      ? filterByOwner
      : filterByOwner?.filter((item) =>
          selectedLinkedPlans.includes(item.planName)
        );
  }, [linkedSpecificAccount, selectedLinkedPlans]);

  const filteredAccountOpts = useMemo(() => {
    return selectedLinkedPlans?.includes("All")
      ? specificAccountsOptions
      : specificAccountsOptions?.filter((item) =>
          hasAtLeastOneSelectedPlan(item.plans, selectedLinkedPlans)
        );
  }, [selectedLinkedPlans, specificAccountsOptions]);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleSelectChange = (selectedOption) => {
    setSelectedOptions(selectedOption);
    setLinkedSites(selectedOption);
  };

  useEffect(() => {
    if (editsingleObject?.linkedSites) {
      const defaultOptions = editsingleObject?.linkedSites?.map((item) => ({
        value: item?._id,
        label: item?.careSiteName,
      }));
      setSelectedOptions(defaultOptions);
    }
  }, [editsingleObject]);

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid min_height">
          <div className="card">
            <div className="card-body">
              <div className="top_menubar">
                <div className="row">
                  <div className="col">
                    <h5>{editsingleObject?.couponType}</h5>
                  </div>
                </div>
              </div>

              <div className="">
                <div
                  className="row"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className={`col-12 col-md-5 col-lg-5 ${cx.cardBox}`}>
                    <h5>
                      Plan Details
                      <span
                        className={`${cx.editIcon}`}
                        onClick={() => {
                          handleShow("Edit Coupon Details");
                        }}
                      >
                        Edit
                      </span>
                    </h5>
                    <ul style={{ fontSize: "15px" }}>
                      <li>Coupon Type: {editsingleObject?.couponType}</li>
                      <li>Coupon ID: {editsingleObject?.couponId}</li>
                      <li>Coupon Creation Date: {creationDate}</li>

                      {/* <li>Linked Add-ONs: {editsingleObject?.linkedAddOn}</li> */}
                      <li>Add-ON Status: {editsingleObject?.addOnStatus}</li>
                    </ul>
                  </div>
                  <div className={`col-12 col-md-5 col-lg-5 ${cx.cardBox}`}>
                    <h5>
                      Billing Details
                      <span
                        className={`${cx.editIcon}`}
                        onClick={() => {
                          handleShow("Edit Billing Details");
                        }}
                      >
                        Edit
                      </span>
                    </h5>
                    <ul style={{ fontSize: "15px" }}>
                      <li>
                        Billing Frequency: {editsingleObject?.billFrequency}
                      </li>
                      <li>Discount Type: {editsingleObject?.discountType}</li>
                      <li>
                        Discount Value:{" "}
                        {/* {"currency" in editsingleObject &&
                          getSymbolFromCurrency(
                            editsingleObject?.currency
                          )}{" "} */}
                        {twoDecimalPlaces(editsingleObject?.discountValue)}
                      </li>
                      <li> </li>
                      <li> </li>
                    </ul>
                  </div>
                </div>
                {/* Breaking Point here */}
                <div
                  className="row"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className={`col-12 col-md-5 col-lg-5 ${cx.cardBox}`}>
                    <h5>
                      Redemption Details
                      <span
                        className={`${cx.editIcon}`}
                        onClick={() => {
                          handleShow("Edit Redemption Details");
                        }}
                      >
                        Edit
                      </span>
                    </h5>
                    <ul style={{ fontSize: "15px" }}>
                      <li>
                        Type: <hr />
                        {/* {editsingleObject?.redemptionType === "0"
                          ? "Indefinite"
                          : editsingleObject?.redemptionType === "1"
                          ? "One Time"
                          : +editsingleObject?.redemptionType >= +"2"
                          ? "Few No. of Times (Applied at each time an invoice is issued)"
                          : ""} */}
                      </li>
                      <li>
                        <label className="d-block">
                          <input
                            type="checkbox"
                            disabled
                            checked={editsingleObject?.redemptionType === 1}
                            style={{ width: "auto", marginRight: "20px" }}
                          />{" "}
                          One Time
                        </label>

                        <label className="d-block mt-3">
                          <input
                            type="checkbox"
                            disabled
                            checked={editsingleObject?.redemptionType === 0}
                            style={{ width: "auto", marginRight: "20px" }}
                          />{" "}
                          Indefinite{" "}
                        </label>

                        <label className="d-block mt-3">
                          <input
                            type="checkbox"
                            disabled
                            checked={+editsingleObject?.redemptionType >= +"2"}
                            style={{ width: "auto", marginRight: "20px" }}
                          />{" "}
                          Few No. of Times (Applied at each time an invoice is
                          issued){" "}
                          <span className="float-end">
                            {editsingleObject?.redemptionType}
                          </span>
                        </label>
                      </li>
                    </ul>
                    <div
                      className="mt-3"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          editsingleObject?.couponCode
                        );
                      }}
                    >
                      Coupon Code:{" "}
                      <strong>{editsingleObject?.couponCode}</strong>
                    </div>
                  </div>
                  <div className={`col-12 col-md-5 col-lg-5 ${cx.cardBox}`}>
                    <h5>
                      Links
                      <span
                        className={`${cx.editIcon}`}
                        onClick={() => {
                          handleShow("Edit Links");
                        }}
                      >
                        Edit
                      </span>
                    </h5>
                    <ul style={{ fontSize: "15px" }}>
                      <li>
                        Linked Site:
                        {editsingleObject.linkedSites?.[0] === "All" ||
                        editsingleObject.linkedSites?.[0] === "existingUsers" ||
                        editsingleObject.linkedSites?.[0] === "newUsers"
                          ? editsingleObject?.linkedSites?.[0]
                          : editsingleObject.linkedSites
                              ?.map((item) => item?.careSiteName)
                              ?.join(", ")}
                      </li>
                      <li>
                        Linked Plans:{" "}
                        {typeof editsingleObject.linkedPlan === "string"
                          ? editsingleObject?.linkedPlan
                          : editsingleObject?.linkedPlan?.join(", ")}
                      </li>
                      <li>
                        Linked Add-Ons:
                        {typeof editsingleObject?.linkedAddOn === "string"
                          ? editsingleObject?.linkedAddOn
                          : editsingleObject?.linkedAddOn?.join(", ")}
                      </li>
                      <li>
                        Linked Account:
                        {editsingleObject?.linkedAccount?.[0] === "All" ||
                        editsingleObject?.linkedAccount?.[0] ===
                          "existingUsers" ||
                        editsingleObject?.linkedAccount?.[0] === "newUsers"
                          ? editsingleObject?.linkedAccount?.[0]
                          : editsingleObject?.linkedAccount
                              ?.map((item) => item?.companyName)
                              .join(", ")}
                      </li>
                      <li></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupStatus === "Edit Coupon Details" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <span>Edit Coupon Details</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Coupon Name</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editsingleObject?.couponType}
                    onChange={(e) => {
                      setPlanName(e.target.value);
                    }}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Linked Plans</label>
                  <Select
                    isMulti
                    defaultValue={[
                      {
                        value: editsingleObject.linkedPlan,
                        label: editsingleObject.linkedPlan,
                      },
                    ]}
                    options={LinkedPlansOption}
                    onChange={linkedPlansHandleChange}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editPlanDetails();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {popupStatus === "Edit Billing Details" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <span>Edit Billing Details</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Currency</label>
                  <Select
                    defaultValue={{
                      value: editsingleObject.currency,
                      label: editsingleObject.currency,
                    }}
                    options={currencyOptions}
                    onChange={currencyHandler}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Bill Frequency</label>
                  <Select
                    defaultValue={{
                      value: editsingleObject.billFrequency,
                      label: editsingleObject.billFrequency,
                    }}
                    options={billFrequencyOptions}
                    onChange={billFrequencyHandler}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Discount Type</label>
                  <Select
                    defaultValue={{
                      value: editsingleObject.discountType,
                      label: editsingleObject.discountType,
                    }}
                    options={discountOptions}
                    onChange={discountHandler}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Discount Value</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={twoDecimalPlaces(
                      editsingleObject?.discountValue
                    )}
                    onChange={(e) => {
                      setdiscountValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editBillingDetails();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {popupStatus === "Edit Redemption Details" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <span>Edit Redemption Details</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Redemption Type</label>
                  {/* we can also do the redemption part with objects like {name:"type",value:'0,1,2....'} */}
                  <Select
                    defaultValue={
                      editsingleObject?.redemptionType == 0
                        ? { value: "indefinite", label: "Indefinite" }
                        : editsingleObject?.redemptionType == 1
                        ? { value: "one_time", label: "One Time" }
                        : +editsingleObject?.redemptionType >= 2
                        ? {
                            value: "fewno",
                            label:
                              "Few No. of Times (Applied at each time an invoice is issued)",
                          }
                        : {
                            value: "",
                            label: "",
                          }
                    }
                    options={redemptionOptions}
                    onChange={redemptionHandler}
                  />
                </div>
                {redemptionInput && (
                  <div className="col-md-12 mb-3">
                    <label className="mb-1">No. of Redemption</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editsingleObject?.redemptionType}
                      onChange={(e) => {
                        setredemption(e.target.value);
                      }}
                    />
                  </div>
                )}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                onClick={() => {
                  editRedemptionDetails();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}

      {popupStatus === "Edit Links" && (
        <Modal className="viewModal" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <span>Edit Links</span>
              <div className="d-flex">
                <button className="btn" onClick={handleClose}>
                  Close
                </button>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Linked Plans</label>
                  <Select
                    isMulti
                    defaultValue={
                      typeof editsingleObject.linkedPlan === "string"
                        ? editsingleObject.linkedPlan
                            ?.split(" ")
                            ?.map((item) => {
                              return { value: item, label: item };
                            })
                        : editsingleObject.linkedPlan?.map((item) => {
                            return { value: item, label: item };
                          })
                    }
                    options={LinkedPlansOption}
                    onChange={linkedPlansHandleChange}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Linked Add-Ons</label>
                  <Select
                    isMulti
                    defaultValue={
                      typeof editsingleObject.linkedAddOn === "string"
                        ? editsingleObject.linkedAddOn
                            ?.split(" ")
                            ?.map((item) => {
                              return { value: item, label: item };
                            })
                        : editsingleObject?.linkedAddOn?.map((item) => {
                            return { value: item, label: item };
                          })
                    }
                    options={LinkedAddOnsOption}
                    onChange={linkedAddOnsHandleChange}
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="mb-1">Linked Account</label>
                  <div>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="specific"
                      defaultChecked={linkedAccount === "specific"}
                      onChange={() => {
                        linkedAccountChangeHandler("specific");
                      }}
                    />
                    <label className="form-check-label mx-2" htmlFor="specific">
                      Specific Users
                    </label>

                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="newUsers"
                      defaultChecked={linkedAccount === "newUsers"}
                      onChange={() => {
                        linkedAccountChangeHandler("newUsers");
                      }}
                    />
                    <label className="form-check-label mx-2" htmlFor="newUsers">
                      New Users
                    </label>
                  </div>
                  {linkedAccount === "specific" && (
                    <div className="col-md-12 mb-3">
                      <Select
                        isMulti
                        defaultValue={
                          editsingleObject?.specificAccount &&
                          editsingleObject?.linkedAccount
                            ? editsingleObject?.linkedAccount?.map((item) => ({
                                value: item?._id, // or use item.companyName, or any other property
                                label: item?.companyName, // or use item._id, or any other property
                              }))
                            : []
                        }
                        options={filteredAccountOpts}
                        onChange={linkedSpecificAccountChangeHandler}
                      />
                    </div>
                  )}
                </div>
                {linkedAccount === "specific" && (
                  <div className="col-md-12 mb-3">
                    <label className="mb-1">Linked Site*</label>
                    <Select
                      isMulti
                      value={selectedOptions}
                      options={filteredSiteOpts}
                      onChange={handleSelectChange}
                    />
                  </div>
                )}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <button
                type="button"
                className="btn"
                disabled={
                  linkedAccount === "specific" && selectedOptions?.length < 1
                }
                onClick={() => {
                  editLinksDetails();
                }}
              >
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </Fragment>
  );
}
